import { TIME_TYPE, VOUCHER_TYPE } from '@src/constants/voucher';
import { isFixedCharacterVoucherUsable } from '@src/services/voucher';
import moment from 'moment';

const {
  PACKAGE_LEVEL,
  PACKAGE_CODE,
  PACK_DURATION,
} = require('@src/constants/package');

const checkTodayDisplay = () => {
  const today = moment().format('DD/MM/YYYY');
  const prevDisplayInfo = JSON.parse(
    localStorage.getItem('AUTO_RENEWAL_BANNER'),
  );

  const todayDisplay =
    (!prevDisplayInfo || prevDisplayInfo?.date !== today) &&
    !prevDisplayInfo?.notShowAgain;
  return todayDisplay;
};

const checkShowAutoRenewalPayment = ({
  packageCode = '',
  alwayShow = true,
}) => {
  if (!packageCode) return false;

  const isFreePackage =
    packageCode.includes(PACKAGE_LEVEL.TRIAL) ||
    packageCode.includes(PACKAGE_LEVEL.BASIC) ||
    packageCode.includes(PACKAGE_CODE.STUDIO_FREE);

  if (alwayShow) return !isFreePackage;
  return !isFreePackage && checkTodayDisplay();
};

// Order price must be in VND to evaluate against FIXED_CHARACTER voucher's minimumOrderPrie
const getOrderPackageInfoWhenApplyVoucher = ({
  packageInfo,
  voucher,
  orderPrice,
}) => {
  const { type, value, timeType } = voucher || {};
  if (type === VOUCHER_TYPE.CHARACTER) {
    const customMaxCharacters = packageInfo?.maxCharacters * value;
    const customCredits = packageInfo?.maxCredits
      ? packageInfo?.maxCredits * value
      : 0;
    const customCreditsPerCycle = packageInfo?.cycle?.creditsPerCycle * value;
    const creditsCycleFromVoucher =
      customCreditsPerCycle - packageInfo?.cycle?.creditsPerCycle;
    return {
      ...packageInfo,
      maxCharacters: customMaxCharacters,
      maxCredits: customCredits,
      cycle: { ...packageInfo?.cycle, creditsPerCycle: customCreditsPerCycle },
      creditsCycleFromVoucher,
      maxCharactersFromVoucher:
        customMaxCharacters - packageInfo?.maxCharacters,
      maxCreditsFromVoucher: customCredits - packageInfo?.maxCredits,
    };
  }
  if (type === VOUCHER_TYPE.FIXED_CHARACTER) {
    const bonusValue = isFixedCharacterVoucherUsable({
      voucher,
      price: orderPrice,
    })
      ? value
      : 0;
    const customMaxCharacters = packageInfo?.maxCharacters + bonusValue;
    const customCredits = packageInfo?.maxCredits
      ? Number(packageInfo.maxCredits) + bonusValue
      : 0;
    let customCreditsPerCycle = packageInfo?.cycle?.creditsPerCycle;
    const isMonthlyPackage = packageInfo?.expiresIn === PACK_DURATION.MONTH;
    const isYearlyPackage = packageInfo?.expiresIn === PACK_DURATION.YEAR;
    if (isMonthlyPackage) customCreditsPerCycle += bonusValue;
    if (isYearlyPackage) {
      const fixedCreditsPerCycle = Math.ceil(
        bonusValue / packageInfo?.cycle?.totalCycles,
      );
      customCreditsPerCycle += fixedCreditsPerCycle;
    }
    const creditsCycleFromVoucher =
      customCreditsPerCycle - packageInfo?.cycle?.creditsPerCycle;
    return {
      ...packageInfo,
      maxCharacters: customMaxCharacters,
      maxCredits: customCredits,
      cycle: {
        ...packageInfo?.cycle,
        creditsPerCycle: customCreditsPerCycle,
      },
      creditsCycleFromVoucher,
      maxCharactersFromVoucher:
        customMaxCharacters - packageInfo?.maxCharacters,
      maxCreditsFromVoucher: customCredits - packageInfo?.maxCredits,
    };
  }
  if (type === VOUCHER_TYPE.TIME && timeType === TIME_TYPE.MONTH) {
    const totalCycles = packageInfo?.cycle?.totalCycles + value;
    return {
      ...packageInfo,
      cycle: { ...packageInfo?.cycle, totalCycles },
    };
  }

  // TODO: Handle other voucher types
  return packageInfo;
};

export { checkShowAutoRenewalPayment, getOrderPackageInfoWhenApplyVoucher };
